export const CHECKOUT_URL = 'https://obesidad-it.impultienda.ar/checkout/'

export const KIT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/qFwLWrDUc4J11dLZ9tpc2t/OBESIDAD-IT.png'

export const AUTHOR_IMAGE =
  'https://cdn.magicpatterns.com/uploads/ahPrThjtHtLuYDNkJcAV8s/Dra_Karito_real.png'

export const heroStats = [
  { value: '+300', label: 'Strumenti clinici pronti all’uso' },
  { value: '+2.000', label: 'Medici usano già la metodologia' },
  { value: '6', label: 'Volumi specializzati' },
  { value: '100%', label: 'Digitale • Download immediato' },
]

export const beforeItems = [
  'Consultavi diverse linee guida prima di decidere cosa fare con un paziente.',
  'Avevi dubbi nella scelta del trattamento farmacologico più adatto.',
  'Perdevi tempo interpretando esami di laboratorio e biomarcatori.',
  'Improvvisavi quando un paziente smetteva di rispondere al trattamento.',
  'I pazienti interrompevano il trattamento perché non comprendevano cosa aspettarsi.',
  'Trascorrevi ore a consultare articoli scientifici.',
]

export const afterItems = [
  'Segui un percorso passo dopo passo che organizza cosa valutare in ogni fase.',
  'Decidi con algoritmi clinici organizzati in base al profilo del paziente.',
  'Usi tabelle e criteri di interpretazione a supporto delle decisioni cliniche.',
  'Sai cosa rivalutare quando compare un plateau o una risposta insufficiente.',
  'Usi risorse educative per far comprendere al paziente il suo percorso.',
  'Tutte le informazioni rilevanti in un unico Percorso Clinico pratico.',
]

export const painPoints = [
  {
    emoji: '😰',
    text: 'Hai davanti un paziente con obesità e non sei del tutto sicuro di quale approccio terapeutico sia più appropriato per il suo profilo clinico.',
  },
  {
    emoji: '⏱️',
    text: 'Perdi troppo tempo consultando linee guida, consensus o articoli per confermare una decisione che devi prendere in quel momento.',
  },
  {
    emoji: '🤔',
    text: 'Quando il paziente non risponde, ti chiedi se rivalutare la strategia, modificare il trattamento o approfondire altri fattori.',
  },
  {
    emoji: '📋',
    text: 'Vorresti una metodologia chiara per valutare i pazienti senza dimenticare esami, criteri o passaggi importanti.',
  },
  {
    emoji: '💬',
    text: 'Alcuni pazienti interrompono il trattamento perché non comprendono cosa aspettarsi o perdono la motivazione nel follow-up.',
  },
  {
    emoji: '💉',
    text: 'Vuoi usare con maggiore sicurezza farmaci come semaglutide o tirzepatide, ma hai dubbi su indicazioni, titolazione e monitoraggio.',
  },
]

export const volumes = [
  {
    emoji: '📘',
    number: 'Volume 1',
    title: 'Domina la valutazione fin dalla prima visita',
    text: 'Identifica il profilo clinico del paziente, organizza la valutazione iniziale e definisci un piano di gestione strutturato dal primo incontro.',
  },
  {
    emoji: '💊',
    number: 'Volume 2',
    title: 'Scegli la strategia terapeutica con maggiore sicurezza',
    text: 'Organizza la valutazione delle opzioni farmacologiche, i criteri di scelta, la titolazione e gli aspetti da monitorare durante il trattamento.',
  },
  {
    emoji: '🧪',
    number: 'Volume 3',
    title: 'Trasforma gli esami di laboratorio in decisioni cliniche',
    text: 'Organizza l’interpretazione di biomarcatori ed esami attraverso tabelle, criteri e strumenti basati sulle evidenze.',
  },
  {
    emoji: '📈',
    number: 'Volume 4',
    title: 'Gestisci plateau e risultati insufficienti senza improvvisare',
    text: 'Struttura la rivalutazione quando il paziente raggiunge un plateau, presenta una risposta insufficiente o necessita di una nuova valutazione.',
  },
  {
    emoji: '🩺',
    number: 'Volume 5',
    title: 'Affronta i casi clinici più complessi',
    text: 'Scenari con diabete, ipertensione, insulino-resistenza, obesità severa, menopausa e altre situazioni che complicano la gestione.',
  },
  {
    emoji: '🧰',
    number: 'Volume 6',
    title: 'Accelera le tue visite con strumenti pronti all’uso',
    text: 'Checklist, algoritmi, modelli, tabelle e risorse visive per organizzare ogni visita e ridurre il tempo dedicato alla ricerca.',
  },
]

export const deliverables = [
  {
    emoji: '📘',
    title: 'I 6 Volumi del Percorso Clinico',
    text: 'Più di 300 algoritmi, protocolli, tabelle e strumenti organizzati per supportare le decisioni più importanti della visita.',
  },
  {
    emoji: '📋',
    title: 'Checklist per valutazione, trattamento e follow-up',
    text: 'Strumenti per standardizzare il tuo approccio clinico e non trascurare passaggi importanti.',
  },
  {
    emoji: '💬',
    title: 'Risorse educative per il paziente',
    text: 'Materiali pronti da usare durante la visita per facilitare la comprensione del percorso terapeutico.',
  },
  {
    emoji: '📱',
    title: 'Materiale digitale scaricabile',
    text: 'PDF ottimizzati per computer, tablet e smartphone.',
  },
]

export const bonuses = [
  {
    tag: 'Bonus #1',
    image:
      'https://cdn.magicpatterns.com/uploads/ceweZcV3mGWvAdtwKdV8K9/BONUS_1_OBESIDAD-IT.png',
    emoji: '🧠',
    title: 'Kit di algoritmi decisionali clinici',
    lead: 'Smetti di consultare molteplici linee guida prima di ogni visita.',
    text: 'Algoritmi visivi organizzati per orientarti nelle principali decisioni cliniche: valutazione, trattamento, monitoraggio e follow-up.',
    bullets: [] as string[],
    value: '€37',
  },
  {
    tag: 'Bonus #2',
    image:
      'https://cdn.magicpatterns.com/uploads/79SJRs66WcXKH6osVaCa17/BONUS_2_OBESIDAD-IT.png',
    emoji: '💬',
    title: 'Script medici per migliorare l’aderenza',
    lead: 'Scopri cosa dire quando un paziente:',
    text: 'Script pratici per comunicare il trattamento con maggiore chiarezza e favorire la comprensione del paziente.',
    bullets: [
      'Ha paura dei farmaci',
      'Rifiuta le iniezioni',
      'Vuole interrompere il trattamento',
      'Crede che “basti la forza di volontà”',
    ],
    value: '€37',
  },
  {
    tag: 'Bonus #3',
    image:
      'https://cdn.magicpatterns.com/uploads/oH7SoA6sPM4zRR2xnMuy82/BONUS_3_OBESIDAD-IT.png',
    emoji: '✅',
    title: 'Pack di checklist professionali',
    lead: 'Standardizza ogni visita e riduci il rischio di dimenticare:',
    text: '',
    bullets: [
      'Valutazioni iniziali',
      'Criteri clinici',
      'Considerazioni farmacologiche',
      'Rivalutazioni del trattamento',
      'Follow-up e controlli periodici',
    ],
    value: '€27',
  },
  {
    tag: 'Bonus #4',
    image:
      'https://cdn.magicpatterns.com/uploads/oR2ys3MnqVzH41MFnPgniQ/BONUS_4_OBESIDAD-IT.png',
    emoji: '📋',
    title: 'Template per l’educazione del paziente',
    lead: 'Materiale professionale pronto da stampare o condividere durante la visita.',
    text: '',
    bullets: [
      'Il percorso terapeutico',
      'Cosa aspettarsi',
      'Gli aspetti da monitorare',
      'Le abitudini da mantenere',
      'Quando tornare al controllo',
    ],
    value: '€47',
  },
  {
    tag: 'Bonus #5',
    image:
      'https://cdn.magicpatterns.com/uploads/8bRF2NZsUwXbCWxa7zvRG8/BONUS_5_OBESIDAD-IT.png',
    emoji: '🩺',
    title: 'Collezione di casi clinici passo dopo passo',
    lead: 'Struttura il ragionamento clinico attraverso scenari come:',
    text: '',
    bullets: [
      'Paziente con diabete di tipo 2',
      'Donna in menopausa',
      'Paziente con insulino-resistenza',
      'Paziente con obesità severa',
      'Plateau nella perdita di peso',
      'Recupero del peso dopo il trattamento',
    ],
    value: '€37',
  },
]

export const valueTable = [
  { item: 'Kit Clinico per la Gestione dell’Obesità — 6 Volumi', value: '€97' },
  { item: 'Kit di Algoritmi Decisionali Clinici', value: '€37' },
  { item: 'Script Medici per Migliorare l’Aderenza', value: '€37' },
  { item: 'Pack di Checklist Professionali', value: '€27' },
  { item: 'Template per l’Educazione del Paziente', value: '€47' },
  { item: 'Collezione di Casi Clinici Passo dopo Passo', value: '€37' },
]

export const testimonials = [
  {
    quote:
      'Prima di conoscere il Percorso Clinico perdevo troppo tempo cercando informazioni prima di visitare i pazienti con obesità. Ora ho una struttura molto più chiara per organizzare la visita.',
    name: 'Dott.ssa Maria P.',
    role: 'Medicina di Famiglia • Colombia 🇨🇴',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/43566b4e-225d-42c1-9d54-058bed0d86f2.jpg',
  },
  {
    quote:
      'Il secondo volume mi ha aiutato a organizzare molto meglio la valutazione delle opzioni terapeutiche. Gli algoritmi sono estremamente pratici.',
    name: 'Dott. Roberto G.',
    role: 'Medicina Interna • Messico 🇲🇽',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/41a71532-0f55-4c8e-808f-daaacba42c94.jpg',
  },
  {
    quote:
      'Le checklist e i casi clinici sono gli strumenti che utilizzo maggiormente. Mi aiutano a mantenere una struttura durante la visita.',
    name: 'Dott.ssa Andrea L.',
    role: 'Endocrinologia • Argentina 🇦🇷',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5bbddbdd-f61b-4576-a585-c44e45f155c3.jpg',
  },
  {
    quote:
      'Gli script per l’aderenza sono molto utili per affrontare le obiezioni dei pazienti e spiegare meglio il percorso terapeutico.',
    name: 'Dott. José V.',
    role: 'Medicina Generale • Spagna 🇪🇸',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/9eaa5bd7-8a7f-4231-adec-97a0f21f707b.jpg',
  },
]

export const faqs = [
  {
    q: 'Come riceverò il materiale?',
    a: 'Subito dopo il pagamento riceverai un’email con l’accesso per scaricare i 6 Volumi e i 5 Bonus in formato PDF.',
  },
  {
    q: 'Il contenuto è adatto ai medici italiani?',
    a: 'Il materiale è in italiano e organizzato sulla base di evidenze e linee guida internazionali. Le raccomandazioni devono essere sempre adattate alle linee guida italiane, alla normativa vigente e al giudizio clinico del professionista.',
  },
  {
    q: 'Posso consultarlo dallo smartphone?',
    a: 'Sì. I PDF sono ottimizzati per computer, tablet e smartphone, oltre a essere adatti alla stampa.',
  },
  {
    q: 'È un pagamento unico?',
    a: 'Sì. Paghi una sola volta e non ci sono abbonamenti o rinnovi automatici.',
  },
  {
    q: 'Devo essere uno specialista in obesità?',
    a: 'No. Il materiale è progettato per i professionisti sanitari che gestiscono pazienti con obesità e desiderano un approccio più strutturato.',
  },
]

export const purchaseNotices = [
  { name: 'Laura M.', country: 'Spagna 🇪🇸' },
  { name: 'Carlos R.', country: 'Messico 🇲🇽' },
  { name: 'Valentina S.', country: 'Argentina 🇦🇷' },
  { name: 'Andrés P.', country: 'Colombia 🇨🇴' },
  { name: 'Camila T.', country: 'Cile 🇨🇱' },
  { name: 'Miguel A.', country: 'Perù 🇵🇪' },
  { name: 'Sofía G.', country: 'Uruguay 🇺🇾' },
  { name: 'Javier L.', country: 'Ecuador 🇪🇨' },
  { name: 'Daniela V.', country: 'Costa Rica 🇨🇷' },
  { name: 'Ricardo F.', country: 'Panama 🇵🇦' },
]
